import { GeoLocation } from "./types";

export const places: GeoLocation[] = [
  {
    latitude: 55.6759,
    longitude: 12.5655,
    title: `🇩🇰 Copenhagen, Denmark`
  },
  {
    latitude: -27.470125,
    longitude: 153.021072,
    title: `🐨 Brisbane, Australia`
  },
  {
    latitude: 55.47028,
    longitude: 8.45187,
    title: `🌊 Esbjerg, Denmark`
  },
  {
    latitude: 50.450001,
    longitude: 30.523333,
    title: `✊🏽 Kyiv, Ukraine`
  },

  // --- chat gpt generated below
  { "title": "🇦🇷 Buenos Aires, Argentina", "longitude": -58.4438, "latitude": -34.6037 },
  { "title": "🇧🇷 Brasília, Brazil", "longitude": -47.9292, "latitude": -15.7801 },
  { "title": "🇨🇱 Santiago, Chile", "longitude": -70.6483, "latitude": -33.4489 },
  { "title": "🇨🇴 Bogotá, Colombia", "longitude": -74.0721, "latitude": 4.7110 },
  { "title": "🇻🇪 Caracas, Venezuela", "longitude": -66.9036, "latitude": 10.4806 },
  { "title": "🇵🇪 Lima, Peru", "longitude": -77.0428, "latitude": -12.0464 },
  { "title": "🇨🇾 Asunción, Paraguay", "longitude": -57.5759, "latitude": -25.2637 },
  { "title": "🇺🇾 Montevideo, Uruguay", "longitude": -56.1913, "latitude": -34.9011 },
  { "title": "🇧🇴 Sucre, Bolivia", "longitude": -65.2627, "latitude": -19.0333 },
  { "title": "🇬🇾 Georgetown, Guyana", "longitude": -58.1552, "latitude": 6.8013 },
  { "title": "🇸🇷 Paramaribo, Suriname", "longitude": -55.2038, "latitude": 5.8663 },
  { "title": "🇧🇷 Salvador, Brazil", "longitude": -38.5013, "latitude": -12.9714 },
  { "title": "🇧🇷 Porto Alegre, Brazil", "longitude": -51.2300, "latitude": -30.0331 },
  { "title": "🇧🇷 Fortaleza, Brazil", "longitude": -38.5226, "latitude": -3.7172 },
  { "title": "🇪🇨 Quito, Ecuador", "longitude": -78.4678, "latitude": -0.1807 },
  { "title": "🇧🇷 Rio de Janeiro, Brazil", "longitude": -43.1729, "latitude": -22.9068 },
  { "title": "🇧🇷 Manaus, Brazil", "longitude": -60.6500, "latitude": -3.1190 },
  { "title": "🇧🇾 La Paz, Bolivia", "longitude": -68.1193, "latitude": -16.5000 },

  { "title": "🇦🇺 Canberra, Australia", "longitude": 149.1300, "latitude": -35.2809 },
  { "title": "🇫🇯 Suva, Fiji", "longitude": 178.0650, "latitude": -17.7134 },
  { "title": "🇵🇬 Port Moresby, Papua New Guinea", "longitude": 147.1803, "latitude": -9.4438 },
  { "title": "🇳🇿 Wellington, New Zealand", "longitude": 174.7762, "latitude": -41.2867 },
  { "title": "🇼🇸 Apia, Samoa", "longitude": -172.1046, "latitude": -13.8333 },
  { "title": "🇻🇺 Port Vila, Vanuatu", "longitude": 168.3193, "latitude": -17.7333 },
  { "title": "🇸🇧 Honiara, Solomon Islands", "longitude": 159.9500, "latitude": -9.4333 },
  { "title": "🇵🇼 Ngerulmud, Palau", "longitude": 134.6230, "latitude": 7.3667 },
  { "title": "🇹🇻 Funafuti, Tuvalu", "longitude": 179.1941, "latitude": -7.4840 },
  { "title": "🇲🇭 Majuro, Marshall Islands", "longitude": 171.3800, "latitude": 7.1000 },
  { "title": "🇳🇷 Yaren, Nauru", "longitude": 166.9280, "latitude": -0.5477 },
  { "title": "🇰🇮 Tarawa, Kiribati", "longitude": 173.0000, "latitude": 1.3300 },
  { "title": "🇹🇴 Nukuʻalofa, Tonga", "longitude": -175.2000, "latitude": -21.1394 },
  { "title": "🇫🇷 Nouméa, New Caledonia", "longitude": 166.4485, "latitude": -22.2763 },
  { "title": "🇨🇰 Avarua, Cook Islands", "longitude": -159.7778, "latitude": -21.2072 },
  { "title": "🇳🇺 Funafuti, Tuvalu", "longitude": 179.1941, "latitude": -7.4840 },
  { "title": "🇵🇬 Madang, Papua New Guinea", "longitude": 145.7895, "latitude": -5.2075 },
  { "title": "🇦🇺 Adelaide, Australia", "longitude": 138.6000, "latitude": -34.9285 },
  { "title": "🇼🇸 Apia, Samoa", "longitude": -172.1046, "latitude": -13.8333 },

  { "title": "🇮🇳 New Delhi, India", "longitude": 77.2090, "latitude": 28.6139 },
  { "title": "🇨🇳 Beijing, China", "longitude": 116.4074, "latitude": 39.9042 },
  { "title": "🇯🇵 Tokyo, Japan", "longitude": 139.6917, "latitude": 35.6895 },
  { "title": "🇰🇷 Seoul, South Korea", "longitude": 126.9780, "latitude": 37.5665 },
  { "title": "🇹🇷 Ankara, Turkey", "longitude": 32.8597, "latitude": 39.9334 },
  { "title": "🇹🇭 Bangkok, Thailand", "longitude": 100.5167, "latitude": 13.7563 },
  { "title": "🇦🇺 Yerevan, Armenia", "longitude": 40.1792, "latitude": 44.4991 },
  { "title": "🇱🇸 Vientiane, Laos", "longitude": 102.6369, "latitude": 17.9757 },
  { "title": "🇻🇳 Hanoi, Vietnam", "longitude": 105.8542, "latitude": 21.0285 },
  { "title": "🇮🇩 Jakarta, Indonesia", "longitude": 106.8650, "latitude": -6.1751 },
  { "title": "🇹🇯 Dushanbe, Tajikistan", "longitude": 68.7782, "latitude": 38.5598 },
  { "title": "🇧🇴 Kathmandu, Nepal", "longitude": 85.3240, "latitude": 27.7172 },
  { "title": "🇧🇭 Manama, Bahrain", "longitude": 50.5860, "latitude": 26.2235 },
  { "title": "🇮🇱 Jerusalem, Israel", "longitude": 35.2137, "latitude": 31.7683 },
  { "title": "🇸🇾 Damascus, Syria", "longitude": 36.3060, "latitude": 33.5138 },
  { "title": "🇪🇬 Cairo, Egypt", "longitude": 31.2357, "latitude": 30.0444 },
  { "title": "🇲🇾 Kuala Lumpur, Malaysia", "longitude": 101.6869, "latitude": 3.1390 },
  { "title": "🇮🇷 Tehran, Iran", "longitude": 51.3890, "latitude": 35.6892 },
  { "title": "🇵🇰 Islamabad, Pakistan", "longitude": 73.0479, "latitude": 33.6844 },
  { "title": "🇰🇼 Kuwait City, Kuwait", "longitude": 47.9774, "latitude": 29.3759 },

  { "title": "🇬🇧 London, United Kingdom", "longitude": -0.1276, "latitude": 51.5074 },
  { "title": "🇩🇪 Berlin, Germany", "longitude": 13.4050, "latitude": 52.5200 },
  { "title": "🇫🇷 Paris, France", "longitude": 2.3522, "latitude": 48.8566 },
  { "title": "🇮🇹 Rome, Italy", "longitude": 12.4964, "latitude": 41.9028 },
  { "title": "🇪🇸 Madrid, Spain", "longitude": -3.7038, "latitude": 40.4168 },
  { "title": "🇳🇱 Amsterdam, Netherlands", "longitude": 4.9041, "latitude": 52.3676 },
  { "title": "🇧🇪 Brussels, Belgium", "longitude": 4.3499, "latitude": 50.8503 },
  { "title": "🇸🇪 Stockholm, Sweden", "longitude": 18.0686, "latitude": 59.3293 },
  { "title": "🇵🇹 Lisbon, Portugal", "longitude": -9.1395, "latitude": 38.7223 },
  { "title": "🇳🇴 Oslo, Norway", "longitude": 10.7522, "latitude": 59.9139 },
  { "title": "🇬🇷 Athens, Greece", "longitude": 23.7275, "latitude": 37.9838 },
  { "title": "🇨🇭 Bern, Switzerland", "longitude": 7.4474, "latitude": 46.9481 },
  { "title": "🇷🇴 Bucharest, Romania", "longitude": 26.1025, "latitude": 44.4268 },
  { "title": "🇷🇸 Belgrade, Serbia", "longitude": 20.4633, "latitude": 44.8176 },
  { "title": "🇧🇬 Sofia, Bulgaria", "longitude": 23.3219, "latitude": 42.6977 },
  { "title": "🇮🇸 Reykjavik, Iceland", "longitude": -21.8954, "latitude": 64.1355 },
  { "title": "🇦🇹 Vienna, Austria", "longitude": 16.3730, "latitude": 48.2082 },
  { "title": "🇵🇱 Warsaw, Poland", "longitude": 21.0122, "latitude": 52.2298 },
  { "title": "🇮🇪 Dublin, Ireland", "longitude": -6.2603, "latitude": 53.3498 },
  { "title": "🇱🇹 Vilnius, Lithuania", "longitude": 25.2798, "latitude": 54.6892 },

  { "title": "🇪🇬 Cairo, Egypt", "longitude": 31.2357, "latitude": 30.0444 },
  { "title": "🇿🇦 Pretoria, South Africa", "longitude": 28.2293, "latitude": -25.7460 },
  { "title": "🇳🇬 Abuja, Nigeria", "longitude": 7.4951, "latitude": 9.0579 },
  { "title": "🇰🇪 Nairobi, Kenya", "longitude": 36.8219, "latitude": -1.2921 },
  { "title": "🇮🇩 Addis Ababa, Ethiopia", "longitude": 38.7578, "latitude": 9.0316 },
  { "title": "🇲🇷 Nouakchott, Mauritania", "longitude": -15.978, "latitude": 18.0797 },
  { "title": "🇿🇲 Lusaka, Zambia", "longitude": 28.2871, "latitude": -15.3875 },
  { "title": "🇮🇶 Tunis, Tunisia", "longitude": 10.1585, "latitude": 36.8065 },
  { "title": "🇲🇿 Maputo, Mozambique", "longitude": 32.6080, "latitude": -25.9655 },
  { "title": "🇲🇷 Nouakchott, Mauritania", "longitude": -15.978, "latitude": 18.0797 },
  { "title": "🇳🇮 Accra, Ghana", "longitude": -0.2050, "latitude": 5.6037 },
  { "title": "🇩🇿 Algiers, Algeria", "longitude": 3.0588, "latitude": 36.7538 },
  { "title": "🇰🇲 Moroni, Comoros", "longitude": 43.2577, "latitude": -11.7020 },
  { "title": "🇮🇨 Nairobi, Kenya", "longitude": 36.8219, "latitude": -1.2921 },
  { "title": "🇿🇦 Cape Town, South Africa", "longitude": 18.4232, "latitude": -33.9249 },
  { "title": "🇹🇿 Dodoma, Tanzania", "longitude": 35.7392, "latitude": -6.1639 },
  { "title": "🇨🇩 Kinshasa, Democratic Republic of the Congo", "longitude": 15.3136, "latitude": -4.4419 },
  { "title": "🇷🇼 Kigali, Rwanda", "longitude": 30.0583, "latitude": -1.9441 },
  { "title": "🇿🇦 Pretoria, South Africa", "longitude": 28.2293, "latitude": -25.7460 }
];

